import styled from '../styled';
import sx from '@styled-system/css';
import { compose } from 'styled-system';
import variant from '@styled-system/variant';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { Theme } from '../theme';
import { InputProps } from './';
import { styles as textVariants } from '../text';
import { validStyle, invalidStyle, inputVariant } from './shared';

const adornedVariant = variant({
  prop: 'adorned',
  variants: {
    after: {
      paddingRight: 9,
    },
    before: {
      paddingLeft: 9,
    },
  },
});

const TextInput = styled('input', { shouldForwardProp })(
  ({ valid, invalid }: InputProps) =>
    sx({
      willChange: 'padding',
      ...textVariants['1r'],
      width: '100%',
      position: 'relative',
      lineHeight: 1,
      padding: 4,
      border: 0,
      borderRadius: 1,
      '&::placeholder': {
        color: 'gray.3',
      },
      transition:
        'box-shadow .1s linear, backgroundColor .1s linear, color .1s linear, padding .2s ease-out',
      '&:focus': {
        boxShadow: (theme: Theme) =>
          `inset 0 0 0 1px ${theme.colors.red[3]} !important`,
      },
      '&:not(:placeholder-shown)': {
        '&:invalid': !valid && invalidStyle,
        '&:valid': !invalid && validStyle,
      },
      ...(invalid && invalidStyle),
      ...(valid && validStyle),
      '&[disabled]': {
        cursor: 'not-allowed',
        backgroundColor: 'gray.6',
        color: 'gray.4',
      },
    }),
  compose(inputVariant, adornedVariant),
);

export default TextInput;
